import { Card } from '../components/Card'
import { LoginForm } from '../components/LoginForm'
import { LoginShell } from '../components/LoginShell'

/**
 * `/admin` — admin sign-in. Reuses the {@link LoginShell} split-screen
 * branding panel (shared with `/login`) on the left, with the internal-access
 * sign-in card on the right.
 */
export function LoginPage() {
  return (
    <LoginShell>
      <Card>
        {/* Header */}
        <header className="flex flex-col gap-1">
          <h1 className="text-[22px] font-bold tracking-tight text-brand-dark-text">
            Admin sign in
          </h1>
          <p className="text-[13px] text-brand-copyright">
            AMLiQ control panel — internal access
          </p>
        </header>

        {/* Username + password form */}
        <LoginForm />

        {/* Footer disclaimer */}
        <footer className="text-center">
          <p className="text-xs text-brand-muted leading-normal">AMLiQ internal use only.</p>
        </footer>
      </Card>
    </LoginShell>
  )
}
